module.exports = "<div ng-if=negotiatedRateCtrl.hasCustomerNegotiatedRates() tooltip-append-to-body=true uib-tooltip=\"{{'Customer rate'}}\" class=i-customer-negotiated></div><div ng-if=negotiatedRateCtrl.hasNegotiatedRatesOrIsKtPreferred() tooltip-append-to-body=true uib-tooltip=\"{{ 'Key Travel recommends' }}\" class=i-kt-preferred></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/widgets/negotiated-rate/negotiated-rate.html
// module id = 790
// module chunks = 0